import { cardPageController, GenericComponent, translate } from 'magner';
import { ModerationCard } from 'features/moderation/types/gaz';
import { moderationApprove, moderationGet, moderationReject } from 'features/moderation/requests/gaz';

const fioField: GenericComponent<ModerationCard> = {
  type: 'input',
  name: 'fio',
  label: translate('hubstr.moderation.form.fio.label'),
  props: { disabled: true },
};

const phoneField: GenericComponent<ModerationCard> = {
  type: 'input',
  name: 'phone',
  label: translate('hubstr.moderation.form.phone.label'),
  props: { disabled: true },
};

const emailField: GenericComponent<ModerationCard> = {
  type: 'input',
  name: 'email',
  label: translate('hubstr.moderation.form.email.label'),
  props: { disabled: true },
};

const departmentField: GenericComponent<ModerationCard> = {
  type: 'input',
  name: 'departmentName',
  label: translate('hubstr.moderation.form.department.label'),
  props: { disabled: true },
};

const moderationConfig = cardPageController<ModerationCard>({
  header: {
    title: translate('hubstr.moderation.form.title'),
  },

  getRequest: moderationGet,
  /** Заявки не создаются из админки (роута new нет) — обязательное поле типа */
  createRequest: moderationApprove,
  /** «Одобрить» → перевод в active, заявка уходит из списка */
  updateRequest: moderationApprove,
  /** «Отклонить» → status остаётся blocked, проставляется решение */
  deleteRequest: moderationReject,

  confirmDelete: translate('hubstr.moderation.form.confirm_reject'),

  form: {
    actions: [
      {
        type: 'action',
        emits: 'cancel',
        props: {
          text: translate('hubstr.moderation.form.cancel_button'),
        },
      },
      {
        type: 'action',
        emits: 'remove',
        props: {
          text: translate('hubstr.moderation.form.reject_button'),
          type: 'danger',
        },
      },
      {
        type: 'action',
        emits: 'submit',
        props: {
          text: translate('hubstr.moderation.form.approve_button'),
          type: 'primary',
        },
      },
    ],

    layout: {
      type: 'column',
      props: {},
      fields: [
        fioField,
        phoneField,
        emailField,
        departmentField,
      ],
    },
  },
});

export default moderationConfig;